import {
  CenterBig,
  LeftBig,
  LeftSmall,
  RightBig,
  RightSmall,
} from 'components/Annotationen'
import styled from 'styled-components'
import { useWindowSize } from 'usehooks-ts'
import { TrainingSize_Desktop } from './ChartDesktop'
import { TrainingSize_Mobile } from './ChartMobile'

const anno_loc_de = [
  <>
    <b>Megatron-Turing NLG</b>
    530 Mrd.
  </>,
  <>
    <b>GPT-3</b>
    175 Mrd.
  </>,
  <>
    <b>Turing-NLG</b>
    17,2 Mrd.
  </>,
  <>
    <b>GPT-2</b>
    1,5 Mrd.
  </>,
  <>
    <b>ELMo</b>
    94 Mio.
  </>,
  <></>,
  <></>,
  <></>,
  <></>,
]

const annos_de = [
  <RightBig style={{ right: '17%', bottom: '88%' }}>{anno_loc_de[0]}</RightBig>,
  <LeftBig style={{ left: '59%', bottom: '55%' }}>{anno_loc_de[1]}</LeftBig>,
  <RightBig style={{ right: '49%', bottom: '44%' }}>{anno_loc_de[2]}</RightBig>,
  <RightBig style={{ right: '60%', bottom: '30%' }}>{anno_loc_de[3]}</RightBig>,
  <LeftBig style={{ left: '1%', bottom: '30%' }}>{anno_loc_de[4]}</LeftBig>,
  <LeftSmall style={{ left: '2%', bottom: '3%' }}>2018</LeftSmall>,
  <LeftSmall style={{ left: '24%', bottom: '3%' }}>2019</LeftSmall>,
  <LeftSmall style={{ left: '50%', bottom: '3%' }}>2020</LeftSmall>,
  <LeftSmall style={{ left: '76%', bottom: '3%' }}>2021</LeftSmall>,
]
const annos_de_mob = [
  <RightBig style={{ right: '19%', bottom: '90%' }}>{anno_loc_de[0]}</RightBig>,
  <RightBig style={{ right: '36%', bottom: '46%' }}>{anno_loc_de[1]}</RightBig>,
  <LeftBig style={{ left: '72%', bottom: '10%' }}>{anno_loc_de[2]}</LeftBig>,
  <RightBig style={{ right: '57%', bottom: '21%' }}>{anno_loc_de[3]}</RightBig>,
  <LeftBig style={{ left: '2%', bottom: '20%' }}>{anno_loc_de[4]}</LeftBig>,
  <LeftSmall style={{ left: '4%', bottom: '1%' }}>2018</LeftSmall>,
  <LeftSmall style={{ left: '25%', bottom: '1%' }}>2019</LeftSmall>,
  <LeftSmall style={{ left: '52%', bottom: '1%' }}>2020</LeftSmall>,
  <LeftSmall style={{ left: '77%', bottom: '1%' }}>2021</LeftSmall>,
]

export const TrainingSize = () => {
  const { width, height } = useWindowSize()
  const annos = width >= 712 ? annos_de : annos_de_mob
  return (
    <StyledTrainingSize>
      <Title>Anzahl der berechneten Parameter<br/> in den Trainingsdaten von Sprachmodellen</Title>
      {width >= 712 && <TrainingSize_Desktop annotations={annos} />}
      {width < 712 && <TrainingSize_Mobile annotations={annos} />}
    </StyledTrainingSize>
  )
}
const StyledTrainingSize = styled.div`
  margin-bottom: 60px;
`
const Title = styled.h3`
  font-family: var(--font-sans-serif);
  font-size: 18px;
  font-weight: 700;
  margin-bottom:30px;
  line-height:1.3em
`
